import React, { forwardRef } from "react";

import s from "./Textarea.module.css";

export const Textarea = forwardRef(
  ({ className = "", disabled = false, ...rest }, ref) => {
    return (
      <textarea
        ref={ref}
        className={`${s.textarea} ${className}`.trim()}
        disabled={disabled}
        {...rest}
      />
    );
  }
);

Textarea.displayName = "Textarea";
